import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "@/data/site";

export const Testimonials = () => {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="py-20 md:py-32 bg-[#0F172A] relative overflow-hidden"
    >
      <div className="absolute inset-0 grain-overlay opacity-[0.04]" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mx-auto text-center">
          <span className="text-sm text-[#7fb0ff] uppercase tracking-[0.2em] font-semibold">
            Testimonials
          </span>
          <h2 className="font-heading text-3xl sm:text-4xl font-bold text-white tracking-tight mt-3">
            What our customers say
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <motion.div
              key={i}
              data-testid={`testimonial-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="bg-white/5 border border-white/10 backdrop-blur-sm p-8 rounded-2xl flex flex-col gap-5"
            >
              <Quote size={32} className="text-[#1656b8] fill-[#1656b8]" />
              <div className="flex gap-1">
                {[...Array(5)].map((_, s) => (
                  <Star key={s} size={16} className="fill-[#F59E0B] text-[#F59E0B]" />
                ))}
              </div>
              <p className="text-slate-200 leading-relaxed flex-1">"{t.quote}"</p>
              <div className="pt-2 border-t border-white/10">
                <div className="font-semibold text-white">{t.name}</div>
                <div className="text-sm text-slate-400">{t.place}</div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
